import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { RecoveryCode } from '@core/interfaces';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

interface GenerateFileToDownloadParams {
  recoveryCodes: RecoveryCode[];
  userEmail: string;
}

@Injectable({
  providedIn: 'root'
})
export class RecoveryCodesService {
  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly translateService: TranslateService
  ) { }

  public generateFileToDownload({ recoveryCodes, userEmail }: GenerateFileToDownloadParams): SafeUrl {
    const formattedRecoveryCodes = recoveryCodes.map((code, index) => {
      const text = `${index + 1}. ${code.plainTextCode}`;
      if (code.status === 'CURRENT_ACTIVE') {
        return text;
      }

      return this.translateService.instant('PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.DOCUMENT.CODE_UTILIZED', {
        position: index + 1,
        code: code.plainTextCode,
      });
    });

    const fileContent = [
      this.translateService.instant('PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.DOCUMENT.TITLE'),
      `(${ userEmail })`,
      '',
      ...formattedRecoveryCodes,
      '',
      this.translateService.instant('PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.DOCUMENT.WARNINGS'),
      this.translateService.instant('PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.DOCUMENT.CREATED_AT', {
        createdAt: moment(recoveryCodes[0].createdAt).format('DD/MM/YYYY')
      })
    ].join('\n');

    const file = new Blob([fileContent], {
      type: 'text/plain;charset=utf-8'
    });

    const urlFile = URL.createObjectURL(file);
    return this.sanitizer.bypassSecurityTrustUrl(urlFile);
  }
}
